import { getFCPRating, getLCPRating } from "./thresholds.js";
const observeFCP = (callback) => {
  if (typeof PerformanceObserver === "undefined") {
    return () => {
    };
  }
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.name === "first-contentful-paint") {
        const fcpSeconds = entry.startTime / 1e3;
        callback({
          name: "FCP",
          value: entry.startTime,
          rating: getFCPRating(fcpSeconds),
          timestamp: Date.now()
        });
      }
    }
  });
  try {
    observer.observe({ type: "paint", buffered: true });
  } catch {
    try {
      observer.observe({ entryTypes: ["paint"] });
    } catch {
      return () => {
      };
    }
  }
  return () => observer.disconnect();
};
const observeLCP = (callback) => {
  if (typeof PerformanceObserver === "undefined") {
    return () => {
    };
  }
  const observer = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    const lastEntry = entries[entries.length - 1];
    if (lastEntry) {
      const lcpSeconds = lastEntry.startTime / 1e3;
      callback({
        name: "LCP",
        value: lastEntry.startTime,
        rating: getLCPRating(lcpSeconds),
        timestamp: Date.now()
      });
    }
  });
  try {
    observer.observe({ type: "largest-contentful-paint", buffered: true });
  } catch {
    return () => {
    };
  }
  return () => observer.disconnect();
};
const getFCP = () => {
  if (typeof performance === "undefined") return null;
  const entries = performance.getEntriesByType("paint");
  const fcpEntry = entries.find((e) => e.name === "first-contentful-paint");
  return fcpEntry ? fcpEntry.startTime : null;
};
const getNavigationTiming = () => {
  if (typeof performance === "undefined") return null;
  const entries = performance.getEntriesByType(
    "navigation"
  );
  if (entries.length === 0) return null;
  const nav = entries[0];
  return {
    dnsLookup: nav.domainLookupEnd - nav.domainLookupStart,
    tcpConnection: nav.connectEnd - nav.connectStart,
    serverResponse: nav.responseEnd - nav.requestStart,
    domContentLoaded: nav.domContentLoadedEventEnd - nav.startTime,
    loadComplete: nav.loadEventEnd - nav.startTime
  };
};
const markPerformance = (name) => {
  if (typeof performance !== "undefined" && performance.mark) {
    performance.mark(name);
  }
};
const measurePerformance = (name, startMark, endMark) => {
  if (typeof performance === "undefined" || !performance.measure) {
    return null;
  }
  try {
    const measure = performance.measure(name, startMark, endMark);
    return measure.duration;
  } catch {
    return null;
  }
};
const clearPerformanceMarks = (markName, measureName) => {
  if (typeof performance === "undefined") return;
  if (markName) {
    performance.clearMarks(markName);
  } else {
    performance.clearMarks();
  }
  if (measureName) {
    performance.clearMeasures(measureName);
  } else {
    performance.clearMeasures();
  }
};
export {
  clearPerformanceMarks,
  getFCP,
  getNavigationTiming,
  markPerformance,
  measurePerformance,
  observeFCP,
  observeLCP
};
//# sourceMappingURL=metrics.js.map
